import { useCallback } from 'react';
import { api } from '../api/client';
import { RecruiterWorkspaceDashboard, RecruiterWorkspaceJobDetail } from '../types/recruiterWorkspace';

export const useRecruiterWorkspaceService = () => {
    const getDashboard = useCallback(async (): Promise<RecruiterWorkspaceDashboard> => {
        const response = await api.get('/api/RecruiterWorkspace');
        return response.data;
    }, []);

    const getJob = useCallback(async (jobPostingId: string): Promise<RecruiterWorkspaceJobDetail> => {
        const response = await api.get(`/api/RecruiterWorkspace/Jobs/${jobPostingId}`);
        return response.data;
    }, []);

    return { getDashboard, getJob };
};
